import { Typography } from '../../components/primitives';
import { ProjectsProvider } from '../../context/projects.context';
import { testId } from '../../utils';
import { Projects } from '../projects/projects';
import { useTranslation } from '@rpi/i18n';
import { Link } from 'react-router-dom';

const DashboardRoute = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'route.dashboard' });
  return (
    <div className="space-y-12 flex flex-col">
      <Typography
        as="h1"
        variant="title-default"
        {...testId('dashboard-title')}
      >
        {t('dashboard_title')}
      </Typography>
      <div className="space-y-4">
        <Typography
          as="p"
          variant="sub-title"
          {...testId('recent-projects-title')}
        >
          {t('recent_projects')}
        </Typography>
        <ProjectsProvider>
          <Projects isDashboard={true} />
        </ProjectsProvider>
        <div className="flex justify-end">
          <Link {...testId('view-all', 'link')} to="/user/projects">
            {t('view_all')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DashboardRoute;
